<script>
import appConfig from "@src/app.config";

export default {
  components: {},
  data: function() {
    return {
      appConfig: appConfig
    };
  }
};
</script>

<template>
  <!-- Footer Start -->
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <span class="footer-text">
            Copyright 2020 © {{ appConfig.company }}. Todos os direitos
            reservados.
          </span>
        </div>
        <div class="col-md-6">
          <div class="text-md-right footer-links d-none d-sm-block">
            <a :href="'mailto:' + appConfig.contact">Entre em contato</a>
            <a :href="appConfig.about">Sobre nós</a>
            <a :href="'mailto:' + appConfig.contact">Ajuda</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end Footer -->
</template>
